import { APIClient } from './APIClient'

export const fetchPolygons = (language) => {
    return APIClient.get(`/v1/${language}/geospatial/polygons`)
}
